var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iotplt-card-box",staticStyle:{"min-height":"320px"}},[_c('a-empty',{attrs:{"description":"功能开发中"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }